import Errored from '../../core/Errored';
import { Typography } from '@material-ui/core';
import GS from '../../grafsync/grafsync';
import IRIentry from '../../core/IRIentry';
import { lightSanitiseText, makeCancelable } from '../../core/utils/utils';
import LabelledSwitch from '../../core/LabelledSwitch';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import ProjectLanguageSelector from '../../core/ProjectLanguageSelector';
import TitledPanel from '../../core/TitledPanel';
import TitledTextField from '../../core/TitledTextField';
import CancelButton from '../../core/CancelButton';
import PrimaryButton from '../../core/PrimaryButton';
import { globalStyles as styles } from '../../core/style/gstheme';

class AddSuggestionNoteDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: true,
            text: "",
            useXL: props.useXL,
            lang: this.props.defaultLang,
            processingIRI: false,
            iriTheSame: false,
            resourceIRI: "",
            labelResourceIRI: "",
            computedIRI: props.resourceIRI,
            labelComputedIRI: props.labelResourceIRI,
            uniqueIRI: false,
            uniqueLabelIRI: false,
            viewIRI: false,
            iriRejected: false,
            labelIriRejected: false,
            isErrored: null
        };
        this.cancellable = null;
    }

    componentWillUnmount() {
        if (this.cancellable) this.cancellable.cancel();
    }

    handleXLChange = checked => this.setState({ useXL: checked });

    loadIDs() {
        this.cancellable = makeCancelable(this.reserveIDs());
        return this.cancellable;
    }

    reserveIDs = async () => {
        this.setState({ processingIRI: true });
        const isFound = await GS.reserveIRI(this.state.resourceIRI, this.props.graph, "http://www.w3.org/2004/02/skos/core#Concept");
        const exists = isFound.exists;
        if (exists) {
            this.rejectIRI(true);
            return false;
        }
        const reservationID = isFound.id;
        let labelReservationID;
        if (this.state.createAsXL) {
            const isLabelFound = await GS.reserveIRI(this.state.labelResourceIRI, this.props.graph, "http://www.w3.org/2008/05/skos-xl#Label");
            const labelExists = isLabelFound.exists;
            if (labelExists) {
                this.rejectLabelIRI(true);
                return false;
            }
            labelReservationID = isLabelFound.id;
        }
        return {
            reservationID,
            labelReservationID
        };
    };

    addNote = async () => {
        if (this.props.accepted && this.props.suggestionType === "NewConceptSuggestion") {
            try {
                const ids = await this.loadIDs().promise;
                if (this.cancellable && this.cancellable.isCancelled()) return;
                if (ids === false) return;
            }
            catch (e) {
                if (!this.cancellable || (this.cancellable && !this.cancellable.isCancelled())) this.setState({ isErrored: e });
                return;
            }
        }
        const { lang, text, useXL, resourceIRI, labelResourceIRI } = this.state;
        this.setState({
            open: false,
            text: "",
            useXL: true,
            lang: this.props.defaultLang,
            uniqueIRI: false,
            uniqueLabelIRI: false,
            iriTheSame: false,
            processingIRI: false,
            viewIRI: false,
            iriRejected: false,
            labelIriRejected: false,
            computedIRI: "",
            labelComputedIRI: "",
            resourceIRI: "",
            labelResourceIRI: ""
        });
        if (text !== "") {
            this.props.onAddNote(lang, text, useXL, resourceIRI, labelResourceIRI);
        }
        else {
            this.props.onSkipNote(useXL, resourceIRI, labelResourceIRI);
        }
    };

    cancelAddNote = () => {
        this.setState({
            open: false,
            text: "",
            lang: this.props.defaultLang,
            uniqueIRI: false,
            uniqueLabelIRI: false,
            iriTheSame: false,
            processingIRI: false,
            viewIRI: false,
            iriRejected: false,
            labelIriRejected: false,
            computedIRI: "",
            labelComputedIRI: "",
            resourceIRI: "",
            labelResourceIRI: ""
        });
        this.props.onCancelNote();
    };

    selectLanguage = (lang) => this.setState({ lang });

    handleChange = event => {
        const t = event.target;
        const cleanText = lightSanitiseText(t.value.trimLeft());
        this.setState({ [t.name]: cleanText });
    };

    resetIRIconfirmation = () => this.setState({ uniqueIRI: false, iriRejected: false });

    confirmUniqueIRI = (iri) => {
        this.setState({ uniqueIRI: true, iriRejected: false, resourceIRI: iri, iriTheSame: iri === this.state.labelResourceIRI });
    };

    rejectIRI = () => this.setState({ uniqueIRI: false, iriRejected: true, processingIRI: false });

    resetLabelIRIconfirmation = () => this.setState({ uniqueLabelIRI: false, labelIriRejected: false });

    confirmLabelUniqueIRI = (iri) => {
        this.setState({ uniqueLabelIRI: true, labelIriRejected: false, labelResourceIRI: iri, iriTheSame: iri === this.state.resourceIRI });
    };

    rejectLabelIRI = () => this.setState({ uniqueLabelIRI: false, labelIriRejected: true, processingIRI: false });

    handleShowChange = checked => this.setState({ viewIRI: checked });

    render() {

        const { classes, optionForXL, title, accepted, useSlashIRI, useUuidIRI, graph, suggestionType, iriOptions } = this.props;
        const { text, lang, useXL, computedIRI, viewIRI, isErrored,
            uniqueIRI, uniqueLabelIRI, labelComputedIRI, processingIRI, iriRejected, labelIriRejected, iriTheSame } = this.state;

        if (isErrored) return <Errored data={isErrored} />;

        const invalid = accepted && suggestionType === "NewConceptSuggestion" ?
            processingIRI || (useXL && iriTheSame) || !uniqueIRI || (useXL && !uniqueLabelIRI)
            :
            false;

        return (
            <React.Fragment>
                <Dialog
                    data-test="add-suggestion-note-dialog"
                    maxWidth="md"
                    fullWidth
                    classes={{
                        paper: classes.paper,
                        paperWidthMd: classes.largeDialog,
                    }}
                    className={classes.dialog}
                    open={this.state.open}
                    aria-labelledby="text-dialog-title">
                    <DialogTitle
                        data-test="add-suggestion-note-title"
                        disableTypography
                        className={classes.mainHeading}
                        id="text-dialog-title">
                        {title || "Additional Information"}
                    </DialogTitle>
                    <DialogContent data-test="add-suggestion-note-dialog" style={{ overflow: 'scroll' }}>
                        <form autoComplete="off" noValidate="novalidate">
                            <TitledPanel title="Language">
                                <ProjectLanguageSelector selectedLang={lang} includeLabel={false} onSelect={this.selectLanguage} />
                            </TitledPanel>
                            <TitledTextField
                                dataTest="language-text"
                                name="text"
                                title={"Detail"}
                                margin={true}
                                placeholder="Enter a note relating to your decision"
                                required={false}
                                text={text}
                                multiline={true}
                                rows={3}
                                maxLength={500}
                                onEnter={text.length > 0 && lang !== "" ? this.addItem : null}
                                onChange={this.handleChange} />
                            {suggestionType === "NewConceptSuggestion" &&
                                <div>
                                    {accepted &&
                                        <div style={{ display: 'flex', width: '100%' }}>
                                            {optionForXL &&
                                                <LabelledSwitch
                                                    dataTest="useXL"
                                                    checked={useXL}
                                                    handleChange={this.handleXLChange}
                                                    label="Create as XL Label" />
                                            }
                                            <div style={{ flex: 1, textAlign: 'right' }}>
                                                <LabelledSwitch
                                                    dataTest="show-iri"
                                                    checked={viewIRI}
                                                    disabled={processingIRI}
                                                    handleChange={this.handleShowChange}
                                                    label="View/Edit IRI" />
                                            </div>
                                        </div>
                                    }
                                    {accepted &&
                                        <div>
                                            <IRIentry
                                                title="Concept IRI"
                                                key={computedIRI || "conceptIRI"}
                                                margin={false}
                                                disabled={processingIRI}
                                                visible={viewIRI}
                                                startIRI={computedIRI}
                                                useSlashIRI={useSlashIRI}
                                                graph={graph}
                                                resetIRIconfirmation={this.resetIRIconfirmation}
                                                confirmUniqueIRI={this.confirmUniqueIRI}
                                                rejectIRI={this.rejectIRI}
                                                useUuidIRI={useUuidIRI}
                                            />
                                            {optionForXL && useXL &&
                                                <React.Fragment>
                                                    <IRIentry
                                                        title="Label IRI"
                                                        dataTest="label-iri-entry-field"
                                                        margin={true}
                                                        visible={viewIRI}
                                                        disabled={processingIRI}
                                                        handleIRIclash={iriOptions.handleIRIclash}
                                                        key={labelComputedIRI || "labelIRI"}
                                                        startIRI={labelComputedIRI}
                                                        useSlashIRI={useSlashIRI}
                                                        graph={graph}
                                                        resetIRIconfirmation={this.resetLabelIRIconfirmation}
                                                        confirmUniqueIRI={this.confirmLabelUniqueIRI}
                                                        rejectIRI={this.rejectLabelIRI}
                                                        useUuidIRI={useUuidIRI}
                                                    />
                                                    {iriTheSame && viewIRI && <Typography data-test="two-iris" variant="caption">The two IRIs must be different.</Typography>}
                                                </React.Fragment>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                        </form>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton dataTest="cancel-note" onClick={this.cancelAddNote}>Cancel</CancelButton>
                        <PrimaryButton
                            dataTest="add-suggestion-note"
                            disabled={iriRejected || labelIriRejected || invalid}
                            onClick={this.addNote}>Confirm</PrimaryButton>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

AddSuggestionNoteDialog.defaultProps = {
    optionForXL: false,
    useXL: false,
    accepted: false,
    iriOptions: {}
};

AddSuggestionNoteDialog.propTypes = {
    optionForXL: PropTypes.bool,
    useXL: PropTypes.bool,
    accepted: PropTypes.bool.isRequired,
    title: PropTypes.string,
    defaultLang: PropTypes.string.isRequired,
    labelResourceIRI: PropTypes.string,
    suggestionType: PropTypes.string,
    resourceIRI: PropTypes.string,
    onAddNote: PropTypes.func.isRequired,
    onCancelNote: PropTypes.func.isRequired,
    classes: PropTypes.object,
    iriOptions: PropTypes.object
};

export default withStyles(styles)(AddSuggestionNoteDialog);